import { render, staticRenderFns } from "./PriorityScoreCard.vue?vue&type=template&id=531193fa&scoped=true"
import script from "./PriorityScoreCard.vue?vue&type=script&lang=ts"
export * from "./PriorityScoreCard.vue?vue&type=script&lang=ts"
import style0 from "./PriorityScoreCard.vue?vue&type=style&index=0&id=531193fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531193fa",
  null
  
)

export default component.exports